import isIterable from '../isIterable';
import { register } from './factory';
import Type from './Type';
import Item from './vocabulary/Item';
export class Vocabulary {
    constructor(init) {
        this.type = Type.Vocabulary;
        const {items} = isIterable(init) ? { items: init } : init;
        this.items = Array.from(items, i => new Item(i));
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.items.configurable = false;
        descriptors.type.configurable = false;
        descriptors.type.writable = false;
        Object.defineProperties(this, descriptors);
    }
}
export const klass = Vocabulary;
export default Vocabulary;
register(Type.Vocabulary, Vocabulary);    //# sourceMappingURL=Vocabulary.js.map
